import React from 'react';
import { offer } from '../data/offer';
const chips = ['No forms to fill', 'Refunded to your original payment method', 'Keep the bonuses'];
export function Guarantee() {
  return <section aria-labelledby="guarantee-heading" className="w-full bg-green-deep" data-id="element-105" data-mp="2236cg4d6qnxj">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20 text-center" data-id="element-106" data-mp="1x4bqwunu2l9q">
        <div className="mx-auto flex h-24 w-24 flex-col items-center justify-center rounded-full border-[3px] border-shuttle bg-white/10 text-shuttle-soft" data-id="element-107" data-mp="1x28sbm8m7jte">
          <span className="font-display text-4xl font-bold leading-none" data-id="element-108" data-mp="14gforafhw15k">{offer.guaranteeDays}</span>
          <span className="text-xs font-extrabold uppercase tracking-widest" data-id="element-109" data-mp="1j5luzicr2rmy">Days</span>
        </div>
        <p className="mt-6 text-[11px] font-bold uppercase tracking-[1.6px] text-shuttle-soft" data-id="element-110" data-mp="1ecsq8uha7jav">
          Zero risk
        </p>
        <h2 id="guarantee-heading" className="mt-3 font-display font-bold text-white text-[28px] leading-tight tracking-tight sm:text-5xl" data-id="element-111" data-mp="qmewmzj1tce6">
          Open everything. Lead one group from it.
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base text-white/90" data-id="element-112" data-mp="tymhq7rmlmyp">
          Read the volumes, print a session card, take it into one group. If
          Movement Group Ready doesn&apos;t change how you plan and walk into your
          groups, email us within {offer.guaranteeDays} days and you get every
          cent back.
        </p>
        <ul className="mt-7 flex flex-wrap justify-center gap-2.5" data-id="element-113" data-mp="61yyca6ic0kd">
          {chips.map(chip => <li key={chip} className="rounded-full border border-white/35 px-4 py-2 text-[13px] text-white/95" data-id="element-114" data-mp="b0jp7izvd7w5">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}